import { Dispatch, SetStateAction, useState } from 'react';

export const useStateAlt = <T>(
  value: T | undefined,
  defaultValue: T | (() => T)
): [T, Dispatch<SetStateAction<T>>] => useState(value ?? defaultValue);
